import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";



export const deleteFile = (id, d) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/files/delete_file/", { id, department_id: d })
            .then(({ data }) => {
                dispatch({ type: "FILES", files: data });
            });
    };
};

export const renameFile = (file, newName, d) => {
    ////////console.log(file, newName);
    return (dispatch) => {
        axios.post(API_URL + "/api/files/rename_file/", { id: file.id, isDirectory: file.isDirectory, newName: newName, department_id: d })
            .then(({ data }) => {
                dispatch({ type: "FILES", files: data });
            });
    };
};

    export const createFolder = (folderName, currentFolder, d) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/files/create_folder/", { folderName, currentFolder, department_id: d })
            .then(({ data }) => {
                dispatch({ type: "FILES", files: data });
            });
    };
};


export const renameFileCompliance = (file, newName, compliance_id) => {
  return (dispatch) => {
    axios
      .post(API_URL + "/api/files/rename_file/", {
        id: file.id,
        isDirectory: file.isDirectory,
        newName,
        compliance_id: String(compliance_id) || "1",
      })
      .then(({ data }) => {
        dispatch({ type: "FILES", files: data });
      });
  };
};

export const createFolderCompliance = (folderName, currentFolder, compliance_id) => {
  return (dispatch) => {
    axios
      .post(API_URL + "/api/files/create_folder/", {
        folderName,
        currentFolder,
        compliance_id: String(compliance_id) || "1",
      })
      .then(({ data }) => {
        dispatch({ type: "FILES", files: data });
      });
  };
};


export const getFiles = (d) => {
    ////console.log(API_URL, "Getting Files")
    return (dispatch) => {
        axios.get(API_URL + "/api/files/get_files/?department_id=" + d)
            .then(({ data }) => {
                dispatch({ type: "FILES", files: data });
            });
    };
};

export const getFilesByCompliance = (compliance_id) => {
  return (dispatch) => {
    axios
      .get(API_URL + "/api/files/get_files/?compliance_id=" + compliance_id)
      .then(({ data }) => {
        dispatch({ type: "FILES", files: data });
      })
      .catch((err) => {
        console.error("Error fetching compliance files:", err);
      });
  };
};





export const deleteComplianceFile = (id, c) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/files/delete_compliance_file/", { id, compliance_id: c })
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_FILES", complianceFiles: data });
            });
    };
};

export const renameComplianceFile = (file, newName, c) => {
    ////////console.log(file, newName);
    return (dispatch) => {
        axios.post(API_URL + "/api/files/rename_compliance_file/", { id: file.id, isDirectory: file.isDirectory, newName: newName, compliance_id: c })
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_FILES", complianceFiles: data });
            });
    };
};

export const createComplianceFolder = (folderName, currentFolder, c) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/files/create_compliance_folder/", { folderName, currentFolder, compliance_id: c})
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_FILES", complianceFiles: data });
            });
    };
};

export const getComplianceFiles = (c) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/files/get_compliance_files/?compliance_id=" + c)
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_FILES", complianceFiles: data });
            });
    };
};
